import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { classNames } from 'utils/classNames';

const BASE_CLASS_NAME = 'WorkspaceFullScreenTransition';

export default class WorkspaceFullScreenTransition extends Component {
    static propTypes = {
        onEnter: PropTypes.func.isRequired,
        onExit: PropTypes.func.isRequired,
        children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: null,
    };

    componentDidMount() {
        this.props.onEnter();
    }

    componentWillUnmount() {
        this.props.onExit();
    }

    render() {
        const renderedChildren = this.props.children();

        const baseClassNames = classNames({
            [BASE_CLASS_NAME]: true,
            [this.props.className]: this.props.className,
        });

        return <div className={baseClassNames}>{renderedChildren && React.Children.only(renderedChildren)}</div>;
    }
}
